import React, { FC } from 'react';
import DropZoneUploader from '../../UI/DropZoneUploader/DropZoneUploader';
import usePassportUpload from '../../../hooks/usePassportUpload';
import { AccountSubjectResponse } from '../../../structures/response/AccountSubjectResponse';
import { FileManaged } from '../../../structures/response/FileManaged';
import useAccount from '../../../hooks/useAccount';
import useClosableSnackbar from '../../../hooks/useClosableSnackbar';

interface Props {
  subject?: AccountSubjectResponse;
}

const PassportUploader: FC<Props> = ({ subject }) => {
  const [uploadFiles, deleteFile] = usePassportUpload();
  const { fetchAccountResponse } = useAccount();
  const { showSnackbar } = useClosableSnackbar();

  if (!subject) {
    return null;
  }

  const uploadedIds = subject?.passportDocuments.map((v) => v.id) || [];

  const handleDrop = async (v: File[]) => {
    try {
      await uploadFiles(v, subject.id, uploadedIds);
      fetchAccountResponse();
    } catch (e) {
      showSnackbar('Ошибка загрузки файла');
      console.log(e);
    }
  };

  const handleDelete = async (v: FileManaged | File) => {
    if (!(v instanceof File)) {
      await deleteFile(v.id);
    }
  };

  return (
    <DropZoneUploader
      onDrop={handleDrop}
      onDelete={handleDelete}
      uploaded={subject.passportDocuments || []}
      accept=".jpg,.png,.pdf,.txt,.jpeg"
      acceptLabel="Поддерживаемые типы файлов: png, jpeg, jpg, pdf, txt"
      hasError={false}
      errorText="xЗагрузите: первую страницу и прописку"
    />
  );
};

export default PassportUploader;
